import { render } from "./LeaveRequestDetailView.vue?vue&type=template&id=72c38a5c&scoped=true"
import script from "./LeaveRequestDetailView.vue?vue&type=script&lang=js"
export * from "./LeaveRequestDetailView.vue?vue&type=script&lang=js"

import "./LeaveRequestDetailView.vue?vue&type=style&index=0&id=72c38a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c38a5c"]])

export default __exports__